__webpack_require__.p = "/portfolio/shopping-cart/";